import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setAssistantOpen } from "app/modules/aiAssistant/AIAssistantSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { faMessageBot } from "@fortawesome/pro-regular-svg-icons";
import { isAssistimoRoute } from "app/modules/aiAssistant/shared/assistimoRoutes";
import "./AIAssistantBadge.scss";

const AIAssistantBadge: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  // The pop-up shares the page's chat, so it's only offered elsewhere
  const onAssistimoPage = isAssistimoRoute(location.pathname);

  return (
    <button
      data-test-id="toolbar__open-assistimo-button"
      type="button"
      className="assistimo-badge"
      aria-label="Open Assistimo"
      aria-disabled={onAssistimoPage}
      title={
        onAssistimoPage ? "The Assistimo pop-up can't be used while you're on the Assistimo page" : "Open Assistimo"
      }
      onClick={() => {
        if (!onAssistimoPage) dispatch(setAssistantOpen(true));
      }}
    >
      <FontAwesomeIcon icon={faMessageBot} size="xl" />
    </button>
  );
};

export default AIAssistantBadge;
